/* eslint-disable react/destructuring-assignment */
import React from 'react'
import {
  Modal,
  SemanticICONS
} from 'semantic-ui-react'
import { connect } from 'react-redux'
// Local
import { ENCOUNTER } from '../../../constant'
import PdfEncounterReport from '../../common/pdfEncounterReport'
import HeaderIcon from './HeaderIcon'
import PrinterIcon from '../../icons/Printer/PrinterIcon'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  encounter: any
  links: any
  onClick: any
}

function NavHeaderButtons(props: Props): JSX.Element {
  const {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    currentUser,
    encounter,
    links,
    onClick
  } = props

  const onClickFn = (
    action: keyof typeof ENCOUNTER.ACTION
  ) => {
    if (onClick) {
      onClick(action)
    }
  }

  const actions = [
    {
      name: 'arrow alternate circle left outline' as SemanticICONS,
      popUp: 'Previous Encounter',
      disabled: links.prev === null,
      onClick: () => onClickFn(ENCOUNTER.ACTION.PREVIOUS_ENCOUNTER)
    },
    {
      name: 'arrow alternate circle up' as SemanticICONS,
      popUp: 'Return to Work List',
      onClick: () => onClickFn(ENCOUNTER.ACTION.WORKLIST)
    },
    {
      name: 'arrow alternate circle right outline' as SemanticICONS,
      popUp: 'Next Encounter',
      disabled: links.next === null,
      onClick: () => onClickFn(ENCOUNTER.ACTION.NEXT_ENCOUNTER)
    }
  ]

  return (
    <span>
      {
        actions.map(a => (
          <HeaderIcon
            key={ a.name }
            name={ a.name }
            isDisabled={ !!a.disabled }
            onClick={ a.onClick }
            // SHAWN THIS DOES NOT EXIST !!!!!!!!!!!!!!!
            // color={ a.color }
            popUp={ a.popUp }
            size={ undefined }
            color={ undefined }
          />
        ))
      }
      <Modal
        size="fullscreen"
        trigger={
          <span>
            <PrinterIcon />
          </span>
        }
      >
        <Modal.Content>
          <PdfEncounterReport encounterId={ encounter.id } />
        </Modal.Content>
      </Modal>
    </span>
  )
}

export default connect(mapStateToProps)(NavHeaderButtons)
